import React from 'react';

const Support = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-superfeo-gray via-white to-superfeo-lightpink/30 py-8">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10">
          <h1 className="text-4xl md:text-5xl font-heading font-bold text-superfeo-pink mb-4 tracking-wide">
            SUPPORT CENTER
          </h1>
          <p className="text-lg text-superfeo-darkgray font-body max-w-2xl mx-auto">
            Need help with booking, trip updates, or your mobile app experience? Our team is ready to assist.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
          <div className="bg-white rounded-xl shadow-lg border border-superfeo-lightpink p-6">
            <h2 className="text-xl font-heading font-bold text-superfeo-pink mb-2">Phone / WhatsApp</h2>
            <a href="tel:+255629202626" className="block text-superfeo-darkgray hover:text-superfeo-pink font-body">+255 629 202 626</a>
            <a href="tel:+255763100064" className="block text-superfeo-darkgray hover:text-superfeo-pink font-body">+255 763 100 064</a>
          </div>
          <div className="bg-white rounded-xl shadow-lg border border-superfeo-lightpink p-6">
            <h2 className="text-xl font-heading font-bold text-superfeo-pink mb-2">Email</h2>
            <a href="mailto:support@superfeoexpress.co.tz" className="text-superfeo-darkgray hover:text-superfeo-pink font-body break-all">
              support@superfeoexpress.co.tz
            </a>
          </div>
          <div className="bg-white rounded-xl shadow-lg border border-superfeo-lightpink p-6">
            <h2 className="text-xl font-heading font-bold text-superfeo-pink mb-2">Hours</h2>
            <p className="text-superfeo-darkgray font-body">Daily, 6:00 AM - 10:00 PM (EAT)</p>
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-lg border border-superfeo-lightpink p-8">
          <h2 className="text-2xl font-heading font-bold text-superfeo-pink mb-4">Quick Help Topics</h2>
          <ul className="list-disc pl-6 space-y-2 text-superfeo-darkgray font-body">
            <li>Booking confirmation and ticket reference support.</li>
            <li>Trip schedule updates and boarding-time assistance.</li>
            <li>Refund and cancellation guidance.</li>
            <li>Mobile app install, login, and booking troubleshooting.</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Support;
